<template>
    <div class="contrainer">
		<!-- <div class="login_title">
			<div class="login_img">
				<img src="../../assets/login_logo.png" alt="">
			</div>
			<div class="login_text">
				<span>国家级电子商务虚拟仿真实验教学中心</span>
			</div>
		</div> -->
		<div class="login_banner">
			<div class="login_content">
				<div class="login_content1">
					<div class="content_title">登录</div>
					<div class="content_inputs">
						<div class="content_input">
							<div>
								<img src="../../assets/login_ico1.png" alt="">
							</div>
							<input type="text" placeholder="输入用户名" @keyup.enter="toLogin" v-model="userName">
						</div>
						<div class="content_input">
							<div>
								<img src="../../assets/login_ico2.png" alt="">
							</div>
							<input type="password" placeholder="输入密码" @keyup.enter="toLogin" v-model="password">
						</div>
					</div>
					<!-- <div class="content_text">
						<span>忘记密码></span>
					</div> -->
					<div class="content_button" @click="toLogin()">
						<span>登录</span>
					</div>
				</div>				
			</div>			
		</div>
		<div class="login_copyright">
			<!-- <span>圭臬数智-电子邮件：service@gnszkj.com浙ICP备2021008089号</span> -->
			<span>Copyright©2017-2023 - 菁鹰云 - E-Mail：service@chinatr.cn 粤ICP备2022004540号</span>
		</div>
    </div>
</template>

<script>
import {loginApi , getStudentInfoApi , copyrightApi} from '@/api/login'
import {getLocalStorage,setLocalStorage,setToken} from '@/utils/auth'
export default {
	data() {
		return {
			userName:'',
			password:'',
		}
	},
	created() {
		//this.getList()
	},
	methods: {
		getList(){
			copyrightApi().then(res=>{
				
			})
		},
		toLogin(){
			let form = {
				username:this.userName,
				password:this.password,
			}
			console.log(form)
			console.log(this.$store)
			//this.$store.dispatch('loginByUsername',form)
			// .then(()=>{
			// 	// this.$notify.success({
			// 	// 	title:'登陆成功，欢迎回来'
			// 	// })
			// 	this.$router.go('/')
			// })
			loginApi(form).then(res=>{
				if(res.code==200){
					this.$notify.success({
						title: '登录成功',
						offset: this.$store.state.user.rem
					})
					setToken(res.result.access_token)
					getStudentInfoApi().then(res1=>{
						setLocalStorage(res1.result)
						this.$router.push('/')
					})
				}else {
					this.$notify.error({
						title: res.message,
						offset: this.$store.state.user.rem
					})
				}
			})
		},
	}
}
</script>

<style lang="scss" scoped>
	.contrainer {
		// font-size: 1rem;
		padding-top: 1rem;
		.login_title{
			box-sizing:content-box;
			padding:0.21rem 0.84rem;
			height: 0.76rem;
			line-height: 0.76rem;
			.login_img{
				width: 0.76rem;
				height: 0.76rem;
				float: left;
				img{
					width: 100%;
				}
			}
			.login_text{
				height:0.76rem;
				line-height: 0.76rem;
				float: left;
				margin-left: 0.27rem;				
				span{										
					font-size: 0.34rem;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #222222;					
				}
			}
		}
		.login_banner{
			width:100%;
			min-height: calc(90vh - 1rem);
			//margin-top: 1rem;
			background-image: url(../../assets/login_bg.png);
			background-repeat: no-repeat;
			background-size:100%;
			position: relative;
			.login_content{
				position:absolute;
				right:1.87rem;
				top:50%;
				transform: translateY(-50%);
				width: 5.49rem;
				height: 4.04rem;
				background: #FFFFFF;
				border-radius: 6px;
				.login_content1{
					box-sizing: content-box;
					padding:0 0.37rem;
					.content_title{
						font-size: 0.29rem;
						font-family: SourceHanSansSC;
						font-weight: 500;
						color: #222222;
						margin:0.33rem 0;
					}
					.content_inputs{
						border:1px solid rgba(41, 41, 41, 0.3);
						.content_input{
							height: 0.81rem;
							line-height: 0.81rem;							
							overflow: hidden;
							&:first-child{
								border-bottom:1px solid rgba(41, 41, 41, 0.3);
							}
							div{
								width: 0.77rem;
								height:0.81rem;
								float: left;
								display: flex;
								justify-content: center;
								align-items: center;
								img{
									width:0.25rem;
									height: 0.26rem;
								}
							}
							input{
								margin:0.3rem 0;
								border:0px;
								&:focus { outline: none; }
							}
						}						
					}
					.content_text{
						cursor: pointer;
						height: 0.3rem;
						line-height: 0.3rem;
						span{
							font-size: 0.21rem;
							font-family: SourceHanSansSC;
							font-weight: 500;
							color: #8992B6;	
							float: right;
						}
					}
					.content_button{
						cursor: pointer;
						width: 2.47rem;
						height: 0.46rem;
						background: #DF4811;
						border-radius: 6px;
						margin:0 auto;
						line-height:0.46rem;
						text-align: center;
						margin-top:0.31rem;
						span{
							font-size: 0.21rem;
							font-family: SourceHanSansSC;
							font-weight: 500;
							color: #FFFFFF;
						}
					}
				}
				
			}
		}
		.login_copyright{
			position: fixed;
			bottom: 0.5rem;
			left: 50%;
			transform: translateX(-50%);
			text-align: center;
			margin-top: 0.19rem;
			font-size:0.2rem;
			color:#999999;
		}
	}
	
	
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue